import { useState, useRef } from "react";
import { PositionItemsInOrder } from "../../../refractCommon/miro/PositionItemsInOrder";

const { board } = window.miro;

function isValidItem(item) {
  return (
    (item.type === "sticky_note" && item.parentId === null) ||
    (item.type === "text" && item.parentId === null) ||
    (item.type === "card" && item.parentId === null) ||
    (item.type === "shape" && item.parentId === null) ||
    (item.type === "image" && item.parentId === null) ||
    (item.type === "frame" && item.childrenIds.length === 0)
  );
}

export default function SortByType({ boardSelection }) {
  const [ascendLeft, setAscendLeft] = useState(true);
  const [ascendRight, setAscendRight] = useState(false);
  const [toolOpen, setToolOpen] = useState(false);
  const [setHeight, setHeightState] = useState("0px");
  const content = useRef(null);

  function handleToggleOpen() {
    setToolOpen(!toolOpen);
    setHeightState(toolOpen ? "0px" : `${content?.current?.scrollHeight}px`);
  }

  let sortByTypeTypeIcons = (
    <div className="cs5 ce12 grid">
      <div className="m2 icon icon-sticky-bulk cs1"></div>
      <div className="m2 icon icon-rectangle cs2"></div>
      <div className="m2 icon icon-card cs3"></div>
      <div className="m2 icon icon-text cs4"></div>
      <div className="m2 icon icon-image cs5"></div>
      <div className="m2 icon icon-frame cs6"></div>
    </div>
  );

  async function runSortByType() {
    let items = (await board.getSelection())
      .filter(isValidItem)
      .sort((a, b) => a.type.localeCompare(b.type));

    // // Grouping for later columns by type
    // .reduce((acc, item) => {
    //   if (acc[item.type]) {
    //     acc[item.type].push(item);
    //   } else {
    //     acc[item.type] = [item];
    //   }
    //   return acc;
    // }, {});

    if (ascendLeft) {
      items.reverse();
    }

    await PositionItemsInOrder(items);
  }

  return (
    <div id="sort-by-type-tool" className="grid tool-section mt-0 pb-0">
      <div
        id="sort-by-type-tool-header"
        className={"grid cs1 ce12 mt-0 cursor-pointer mb-0"}
        onClick={(event) => {
          handleToggleOpen();
        }}>
        <div className="cs1 icon m2 icon-tile mt-0 mb-0"></div>
        <div className="h3 cs2 ce11 mt-0 mb-0">Item Type</div>
        <div
          className={
            "cs12 icon m2 mb-0 mt-0 cursor-pointer" +
            " " +
            (toolOpen === false ? " icon-arrow-right" : " icon-arrow-down")
          }></div>
      </div>

      <div
        id="accordion-content"
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className="cs1 ce12 grid accordion mt-0 ">
        <div id="accordion-margin" className="cs1 ce12 grid pb-8">
          <p className="p-medium mt-0 pt-0 cs1 ce12 mb-0">
            Sort items by width, height attributes. Items
          </p>
          <div
            id="sort-by-type-tool-works-on"
            className="help-container grid cs1 ce12 mt-0 mb-8 pt-8">
            <p className="p-small cs1 ce4 mb-0 mt-0">
              Works on
              <b> many:</b>
            </p>

            {sortByTypeTypeIcons}
          </div>
          {/* <label className="radiobutton cs1 ce5 mt-0">
        <input
          type="radio"
          tabIndex="0"
          defaultValue="0"
          name="Ascend Left"
          checked={ascendLeft}
          onChange={() => {
            setAscendLeft(!ascendLeft);
            setAscendRight(ascendLeft);
          }}
        />
        <span>Ascend Left</span>
      </label>
      <label className="radiobutton cs6 ce12 mt-0">
        <input
          type="radio"
          tabIndex="0"
          defaultValue="0"
          name="Ascend Right"
          checked={ascendRight}
          onChange={() => {
            setAscendRight(!ascendRight);
            setAscendLeft(ascendRight);
          }}
        />
        <span>Ascend Right</span>
      </label> */}

          {/* <div className="p-large cs1 ce12 mb-0">Width</div>
      <div className="p-large cs1 ce12 mb-0">Height</div>
      <div className="p-large cs1 ce12 mb-0">Area</div> */}

          <div
            type="button"
            onClick={runSortByType}
            className="button button-primary button-small cs1 ce12 fix-stupid-button">
            Sort
          </div>
        </div>
      </div>
    </div>
  );
}
